/***********************/
//Read Me
// import Pagination from 'components/ThemeComponents/Pagination';

// getRowProps = (rowData) =>{
// 	let data = {};
// 	if( rowData.customer_slates.id !== rowData.agency.id){
// 	  data = {backgroundColor:'yellow'}
// 	}
// 	return data;
// }


// paginationCall = (data) =>{
// 	return this.props.paginationDataCall({...data, exceptResource:['logo_file']});
// }

// <Pagination
// 	ref={(p) => this.pagination = p}
// 	columns = { columns }
// 	getDataCall= { this.paginationCall }
// 	filterView={true}
// 	//getRowProps = { this.getRowProps }
// />
/***********************/
import React, { Component } from "react";
// import { connect } from 'react-redux';
import ReactTable, {} from "react-table";
import 'react-table/react-table.css';
// import { orderActions } from "redux/actions/order-actions";
import { Col } from "react-bootstrap";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import ReactDataToCSV from 'components/ThemeComponents/reactDataToCSV';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import arrayMove from 'array-move';
import _ from "lodash";


const Sortableitem = SortableElement(({items, key, index}) => <div className="rt-tr-group" key={key} index={index}>{items}</div>)
const Sortablediv = SortableContainer(({items}) => <div className="rt-body">{items}</div>)
const Emptytable = () => <div className="rt-body">
        <div className="rt-tr-group">
            <div className="rt-tr -odd" >
                &nbsp;
            </div>
        </div>
        <div className="rt-tr-group">
            <div className="rt-tr -even" >
                &nbsp;
            </div>
        </div>
        <div className="rt-tr-group">
            <div className="rt-tr -odd" >
                &nbsp;
            </div>
        </div>
        <div className="rt-tr-group">
            <div className="rt-tr -even" >
                &nbsp;
            </div>
        </div>
        <div className="rt-tr-group">
            <div className="rt-tr -odd" >
                &nbsp;
            </div>
        </div>
    </div>



const ShowCols = (props) => {
	return props.props.noCols ?
	<div className="clearfix pull-left" style={{width : '100%'}}>
		{props.children}
	</div>
	:
	<Col md={12} className="mt-md">
		{props.children}
	</Col>
}

const ShowRow = (props) => {
	return props.props.noCols ?
	<div className="row">
		{props.children}
	</div>
	:
	<React.Fragment>
		{props.children}
	</React.Fragment>
}

class MoreButtonsPagination extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sorted: '',
			filtered: '',
			pageSize: this.props.pageSize || 10,
			total: 0,
			page: 0,
			data: [],
			pages: 0,
			showAll: false,
            length:false
		};

	}
	dataCall = (page = this.state.page, filtered = this.state.filtered, sorted = this.state.sorted, pageSize = this.state.pageSize) => {
		var data = {
			filter: filtered,
			pageSize: this.state.showAll ? this.state.total : pageSize,
			sort: sorted,
			page: this.state.showAll ? 0 : page
		};
		this.props.getDataCall(data).then(response => {
			this.setState({
				data: response.data.pagination.data,
				pages: response.data.pagination.last_page,
				page: response.data.pagination.current_page,
				total: response.data.pagination.total,
			}, ()=>{
				// this.reactTable.reload();

                this.setState({
                    length: response.data.pagination.data.length
                }, () => {
                    if(this.props.parentCallback){
                        // console.log(response.data.pagination.data.length,'paginationdata');
                     this.props.parentCallback(this.state.length)
                    }
                })
			})
		});
	}
    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState(({data}) => ({
          data: arrayMove(data, oldIndex, newIndex),
        }), async () => {
            let newData = _.cloneDeep(this.state.data)

            await (()=>{
                for(let i = 0; i < newData.length; i++){
                    newData[i].sort_order = i+1;
                }
            })()

            this.setState({
                data: newData
            }, ()=>{
                this.props.updateSort && this.props.updateSort(this.state.data)
            })
        });
      };

	paginationStateData = () => {
		return {...this.state}
	}
	filterSearchHandle = (e) => {
		this.setState({
			'filtered': e.target.value
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.showAll !== this.state.showAll) {
			this.dataCall();
		}
		if (this.state.filtered !== prevState.filtered) {
			this.dataCall();
		}
		// if (prevProps.columns !== this.props.columns) {
		// 	this.forceUpdate();
		// }
	}

	render() {
		const { showAll, data, pages, filtered, pageSize, page } = this.state;
		const { showAllToggle, columns, loadingOrder, filterView, upperContent, lowerContent, filterPlaceHolder, downloadData, minRows, downloadFileName, style, showTotal } = this.props;
		// console.log('columns', columns);
		return (
			<React.Fragment>
				<ShowCols props={this.props}>
					{
						showTotal &&
                        <p>Your query resulted in a total of {this.state.total}.</p>

					}
					{
						upperContent &&
						upperContent
					}
					<ShowRow props={this.props}>
						{
							this.props.addNewBtn &&
							<Col md={8} sm={8} xs={12} >
								{this.props.addNewBtn}
							</Col>
						}
						{
							filterView &&
							<Col className='pull-right' md={4} sm={6} xs={12} >
								<FormInputs
									ncols={["col-md-12"]}
									onChange={this.filterSearchHandle}
									proprieties={[
										{
											type: "text",
											bsClass: "form-control",
											placeholder: `Search ${filterPlaceHolder ? filterPlaceHolder : ''}`,
											onChange: this.filterSearchHandle,
											name: "filter"
										}
									]}
								/>
							</Col>
						}

						{
							this.props.toggleBtns &&
							<Col md={12} className="mb-md">
								{this.props.toggleBtns}
							</Col>
						}
					</ShowRow>

					{
						lowerContent &&
						lowerContent
					}

					{
						showAllToggle &&
						<React.Fragment>
							<Col md={1} className='pull-right text-right pl-xs'>
								<label className="container-check mb-none" style={{ marginTop: "10px", paddingLeft: "28px" }}> Show All <input type="checkbox" name="is_default" className="checkbox" onChange={() => {
									this.setState({ showAll: !showAll })
								}} /><span className="checkmark"></span></label>
							</Col>
						</React.Fragment>
					}
					{
						downloadData &&
						<React.Fragment>
							<Col md={2} className="mt-sm downloadCsv text-right pull-right">
								<ReactDataToCSV
									className="downloadbtn"
									fileName={downloadFileName}
									currentRecordsRef={this.reactTable}
									columnsData={columns[0].columns}
								/>
							</Col>
						</React.Fragment>
					}
					<ShowCols props={this.props}>
						<ReactTable
							minRows={minRows ? minRows : data.length}
							showPagination={showAll ? false : true}
							ref={(r) => this.reactTable = r}
							trProps={this.props.getRowProps}
							noDataText={this.props.noDataText || "No records found"}
							data={data}
							pages={pages}
							columns={columns}
							filtered={filtered}
							pageSizeOptions={this.props.pageSizeOptions}
							defaultPageSize={pageSize}
							pageSize={pageSize}
							loading={loadingOrder}
							defaultSorted={this.props.defaultSorted || []}
							onPageSizeChange={(pageSize) => {
								this.setState({
									pageSize: pageSize
								})
							}}
							style = {style}
							className="-striped listing"
							loadingText={'Loading...'}
							pageData={this.dataCall}
							manual
							// page={page}
							// autoResetPage={true}
							onFetchData={(state, instance) => {
								var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
								state.pageData(state.page + 1, state.filtered, sort, state.pageSize);
							}}
                            TbodyComponent = {(instance) => data.length ? <Sortablediv distance={1} helperClass={`trmoving`} axis={'y'} transitionDuration={400}  onSortEnd={this.onSortEnd} items={instance.children} /> : <Emptytable />}
                            TrGroupComponent = {(instance) => <Sortableitem key={`item-${instance.myProps ? instance.myProps.index : ''}`} index={instance.myProps ? instance.myProps.index : 0} items={instance.children} />}
							getTrProps={(state, rowInfo, columns, instance) => {
								let data = {};
								if (instance.props.trProps) {
									if (rowInfo !== undefined) {
										const rowData = rowInfo.original;
										// console.log('rowData', rowData);
										data = instance.props.trProps(rowData);
									}
								}
								return {
									style: data
								};
							}}
							getTrGroupProps={(state, rowInfo, columns, instance) => {
                            // console.log("🚀 ~ file: MoreButtonsPagination.jsx ~ line 283 ~ MoreButtonsPagination ~ render ~ rowInfo", rowInfo)
								return rowInfo && {myProps: rowInfo}
							}}
						/>
					</ShowCols>
				</ShowCols>
			</React.Fragment>
		);
	}
}


export default MoreButtonsPagination;



